import db from 'mime-db';

export const getBlobExtension = blob => db[blob.type].extensions[0];

export const getExtension = fileName => fileName.split('.').slice(-1)[0];
